module.exports = __webpack_public_path__ + "img/InstrumentNotrun.9d18e384.svg";